/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Date_Of_Birth_LongInputs */

const en_us2_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery and the rate loads can climb both change with age. We use it for the pace, never as a limit.`)
};

const pt_br2_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperação e velocidade de progressão mudam com a idade. Usamos para o ritmo, nunca como limite.`)
};

const es_419_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La recuperación y la velocidad a la que suben las cargas cambian con la edad. La usamos para el ritmo, nunca como límite.`)
};

const pt_pt2_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A recuperação e a velocidade de progressão mudam com a idade. Usamo-la para o ritmo, nunca como limite.`)
};

const fr_fr2_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La récupération et la vitesse de progression des charges changent avec l'âge. On s'en sert pour le rythme, jamais comme limite.`)
};

const de_de2_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erholung und das Tempo, in dem Gewichte steigen können, ändern sich mit dem Alter. Wir nutzen es fürs Tempo, nie als Grenze.`)
};

const it_it2_intake_why_date_of_birth_long = /** @type {(inputs: Intake_Why_Date_Of_Birth_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il recupero e la velocità con cui i carichi possono salire cambiano con l'età. La usiamo per il ritmo, mai come limite.`)
};

/**
* | output |
* | --- |
* | "Recovery and the rate loads can climb both change with age. We use it for the pace, never as a limit." |
*
* @param {Intake_Why_Date_Of_Birth_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_date_of_birth_long = /** @type {((inputs?: Intake_Why_Date_Of_Birth_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Date_Of_Birth_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_date_of_birth_long(inputs)
	if (locale === "es-419") return es_419_intake_why_date_of_birth_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_date_of_birth_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_date_of_birth_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_date_of_birth_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_date_of_birth_long(inputs)
	return en_us2_intake_why_date_of_birth_long(inputs)
});
export { intake_why_date_of_birth_long as "intake.why.date_of_birth.long" }